const AppConfig = require('@/lib/Config/AppConfig');
const Sentry = require('@sentry/browser');
const sentryBeforeSendEventProcessor = require('@/lib/Logging/sentryBeforeSendEventProcessor');

/**
 * This is the first function that each screen's entrypoint should call.
 * It does some basic initialization such as listening for app cache updates and making sure we start at the
 * right route.
 * This runs before Angular is initialised.
 */
const bootstrap = () => {
    console.log('Page loaded with URL', window.location.toString());

    // Block the ability to save and run PP as a file.
    if (window.location.protocol === 'file:') {
        // The pathname for a browser launched from a file is based on the html title of the browser window from which
        // it was saved, so we can use this to work out where the user wanted to go.
        // e.g.
        // /Users/john/Desktop/ProPoint.html
        // /Users/john/Desktop/ProPoint%20Customer%20Screen.html
        // /Users/john/Desktop/ProPoint%20Kitchen%20Screen.html
        // /Users/john/Desktop/ProPoint%20Order%20Status%20Screen.html
        const pathname = window.location.pathname;
        let screen = 'epos/';
        if (pathname.includes('Customer')) {
            screen = 'customer/';
        }
        if (pathname.includes('Kitchen')) {
            screen = 'kitchen/';
        }
        if (pathname.includes('Order')) {
            screen = 'kitchen-customer/';
        }
        const redirect = window.config.eposUrl + '/' + screen;
        window.alert('You are accessing a saved version of ProPoint. You will be redirected to ' + redirect);
        window.location.replace(redirect);
    }

    // Remember the hash that was present when the page loaded.
    // requestedHash will be picked up later on by EposIndexCtrl to send the user where they wanted to go.
    window.requestedHash = window.location.hash;

    /**
     * Force all page loads to start from the index page.
     *
     * @type {string}
     */
    window.location.hash = '#/';

    // Important: This is creating a different instance of AppConfig from the one that will be created by Angular's DI.
    // As it has no dependencies it could be changed so that the file exports the instance, making it a singleton.
    // But for now that change is unnecessarily large.
    let appConfig = new AppConfig();

    window.additionalAngularModules = [];

    // Sentry configuration.
    // Enabled by default unless sentryEnabled is set to false, which is is in development.config.js
    if (appConfig.sentryDsn && appConfig.sentryEnabled !== false) {
        Sentry.init({
            dsn: appConfig.sentryDsn,
            release: appConfig.eposCommit,
            environment: appConfig.environment,
            tags: {
                build: appConfig.eposVersion,
                commit: appConfig.eposCommit,
                branch: appConfig.eposBranch,
            },
            beforeSend(event) {
                // Process the event. We can suppress the event by returning null or modify the event here.
                // Wrapped in try / catch because an error in our logging code should not cause problems elsewhere.
                try {
                    return sentryBeforeSendEventProcessor(event);
                } catch (e) {
                    return null;
                }
            },
        });
    }
};

module.exports = bootstrap;
